import { render } from "./ModalCreateEditCampaign.vue?vue&type=template&id=d94920c2&scoped=true&ts=true"
import script from "./ModalCreateEditCampaign.vue?vue&type=script&lang=ts"
export * from "./ModalCreateEditCampaign.vue?vue&type=script&lang=ts"

import "./ModalCreateEditCampaign.vue?vue&type=style&index=0&id=d94920c2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d94920c2"]])

export default __exports__